import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class AppFeedComponent extends BaseOption {
  static userInterfaceComponent = {
    label: "Card Component",
    component: inspectorTools.APP_FEED_COMPONENT_PICKER,
    props: {},
  };

  static defaultValue = null;
}
